import { connect } from "react-redux";
import { getAutocompleteCustomer, getDetailCustomer } from "actions/Customer";
import { getListPhiKhac } from "actions/PhiKhac";
import { getListPhiKhacHangKy } from "actions/PhiKhacHangKy";
import ChoVayForm from "components/BaoCao/HopDongChoDuyet/ChucNang/Sua/SuaCamDo/ModalSuaCamDo";
import { getComboLoaiTaiSan, showModalLoaiTaiSan } from "actions/LoaiTaiSan";
import {
  getThuocTinhTaiSan,
  getThuocTinhTaiSan1,
} from "actions/ThuocTinhTaiSan";
import { getComboStore } from "actions/Store";
import { getComboNguonKhachHang } from "actions/NguonKhachHang";
import { getTaiSanTheoChoVay } from "actions/TaiSan";
import {
  getTaiSanTheoChoVayTMCD,
  getThuocTinhTaiSanTMCD,
  getLoaiTaiSanTMCD,
  setListTaiSanCamCo,
  postCamDo,
  setEnableEditCustomer,
} from "actions/ThemMoiCamDo";
import {
  setTaiSanCamCo,
  setChoVayEdit,
  getConfigSysTMCD,
  setThuocTinhTaiSan,
  checkEditCustomer,
} from "actions/ThemMoiCamDo";
import { getDetailCustomerSuccess } from "actions/Customer";

const mapStateToProps = (state) => ({
  customer: state.customer,
  user: state.user,
  phikhac: state.phikhac,
  phikhachangky: state.phikhachangky,
  loaitaisan: state.loaitaisan,
  thuoctinhtaisan: state.thuoctinhtaisan,
  store: state.store,
  nguonkhachhang: state.nguonkhachhang,
  camdo: state.camdo,
  cauhinh: state.cauhinh,
  taisan: state.taisan,
  themmoicamdo: state.themmoicamdo,
  phanquyen: state.phanquyen,
  quanlycuahang: state.quanlycuahang,
});

const mapDispatchToProps = (dispatch) => ({
  getAutocompleteCustomer: (dataSearch) =>
    dispatch(getAutocompleteCustomer(dataSearch)),
  getListPhiKhac: (dataSearch) => dispatch(getListPhiKhac(dataSearch)),
  getListPhiKhacHangKy: (dataSearch) => dispatch(getListPhiKhacHangKy(dataSearch)),
  getComboLoaiTaiSan: (dataSearch) => dispatch(getComboLoaiTaiSan(dataSearch)),
  getThuocTinhTaiSan: (dataSearch) => dispatch(getThuocTinhTaiSan(dataSearch)),
  getThuocTinhTaiSan1: (dataSearch) =>
    dispatch(getThuocTinhTaiSan1(dataSearch)),
  getComboStore: (dataSearch) => dispatch(getComboStore(dataSearch)),
  getComboNguonKhachHang: () => dispatch(getComboNguonKhachHang()),
  postCamDo: (dataPost) => dispatch(postCamDo(dataPost)),
  getConfigSysTMCD: (dataSearch) => dispatch(getConfigSysTMCD(dataSearch)),
  getDetailCustomer: (dataSearch) => dispatch(getDetailCustomer(dataSearch)),
  getTaiSanTheoChoVay: (dataSearch) =>
    dispatch(getTaiSanTheoChoVay(dataSearch)),
  getTaiSanTheoChoVayTMCD: (dataSearch) =>
    dispatch(getTaiSanTheoChoVayTMCD(dataSearch)),
  getThuocTinhTaiSanTMCD: (dataSearch) =>
    dispatch(getThuocTinhTaiSanTMCD(dataSearch)),
  getLoaiTaiSanTMCD: (dataSearch) => dispatch(getLoaiTaiSanTMCD(dataSearch)),
  setTaiSanCamCo: (data) => dispatch(setTaiSanCamCo(data)),
  setListTaiSanCamCo: (data) => dispatch(setListTaiSanCamCo(data)),
  setChoVayEdit: (data) => dispatch(setChoVayEdit(data)),
  setThuocTinhTaiSan: (data) => dispatch(setThuocTinhTaiSan(data)),
  showModalLoaiTaiSan: (data) => dispatch(showModalLoaiTaiSan(data)),
  checkEditCustomer: (data) => dispatch(checkEditCustomer(data)),
  setEnableEditCustomer: (data) => dispatch(setEnableEditCustomer(data)),
  getDetailCustomerSuccess: (data) => dispatch(getDetailCustomerSuccess(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChoVayForm);
